<!-- <div *ngIf="currentFileUpload" class="progress">
	<div class="progress-bar progress-bar-info progress-bar-striped"
		role="progressbar" attr.aria-valuenow="{{progress.percentage}}"
		aria-valuemin="0" aria-valuemax="100"
		[ngStyle]="{width:progress.percentage+'%'}">
		{{progress.percentage}}%</div>
</div> -->
<!-- <div class="row taille1">
  <mat-radio-group aria-label="Select an option" *ngIf='showSize'>
      <div class="row">
       <div class="col-md-6">
       <mat-radio-button style="font-family: 'Comfortaa', cursive;font-weight:bold;   padding-left: 0!important;
       font-size: 10px!important;" value="horizontal">horizontal (1.91:1)</mat-radio-button>
       </div>
       <div class="col-md-6 taille2">
        <mat-radio-button style="font-family: 'Comfortaa', cursive;font-weight:bold;   padding-left: 0!important;
        font-size: 10px!important;" value="quare">quare (1:1)</mat-radio-button>
        </div>
      </div>
    </mat-radio-group>
  </div> -->

<!-- <div class="row info-img" style="     position: absolute;   margin-left: 79px;">
    <img src="../../../assets/images/info-intent.png" style="width: 20px;
    padding: 4px;
    margin-left: -10px;

    background-color: #00b7cf;
  
    height: 20px;"  title="image">
    </div> -->
<div class="detailsimageUpload" *ngIf="!editMode">
  <ng-container *ngIf='imagelink'>
    <img [src]="imagelink" />
  </ng-container>
  <ng-container *ngIf='image'>
    <img [src]="image" />
  </ng-container>
</div>
<div class="blocimage" *ngIf="editMode">

  <div *ngIf="isUploading" class="loading-container" style="border: 1px solid #D0D5DD;">
    <div class="spinner-box">
      <div class="circle-border"></div>
    </div>
    <div class="progress-text">Uploading... {{progress.percentage}}%</div>
  </div>

  <ng-container *ngIf="!isUploading">
    <div class="affichage" *ngIf='imagelink || image'>
      <div *ngIf='imagelink'>
        <img [src]="imagelink" />
      </div>
      <div *ngIf='image'>
        <img [src]="image" />
      </div>
    </div>
    <div class="addImage">
      <div class="btn-upload">
        <button type="button" (click)="imgFileInput.click()">
          <img src="../../../assets/images/upload.svg">
        </button>
        <input hidden type="file" #imgFileInput (change)="selectFile($event)" accept='.jpeg, .jpg , .png' />
      </div>
      <div class="txt-upload">
        <p><span (click)="imgFileInput.click()">Click to upload</span> <span class="uploadurl" (click)="URLInput()"> or
            Add
            image from URL</span></p>
      </div>
    </div>
  </ng-container>
</div>

<!-- <div [ngClass]=" imagelink || image ? 'image1n': 'image1'" class="col-md-6">

    <div (click)="imgFileInput.click()" class="img1">


      <button type="button" md-button><img src="../../../assets/images/upload.png" /></button>
      <input hidden type="file" #imgFileInput (change)="selectFile($event)" accept='.jpeg, .jpg , .png' />
      <button class="btn btn-successs" [disabled]="selectedFiles">Drop</button>
    </div>
  </div>
  <div [ngClass]=" imagelink  || image? 'image2n': 'image2'" class="col-md-6 col-sm-6 col-xs-6">

    <div class="img2">
      <button type="button" md-button (click)="URLInput()"> <img src="../../../assets/images/find.png" /></button>
      <button class="btn btn-successs" [disabled]="!selectedFiles">URL</button>

    </div>
  </div> -->

<!--
    
    <label class="btn btn-default"> <input type="file"
      (change)="selectFile($event)">
    </label>
     -->